<template>
  <!-- 转换记录 -->
  <div class="history">
    <!-- header -->
    <nav-header></nav-header>
    <!-- content -->
    <div class="log-wrap">
      <div class="log-content">
        <div class="log-title">转换记录</div>
        <div class="log-text">转换记录将只保留最近30天的转换记录。</div>
        <div class="log-list">
          <div class="log-empty" v-if="showEmpty">
            <img class="log-empty-img" src="../../assets/img/history/empty.png" alt />
          </div>
          <el-table
            width="1200px"
            :header-cell-style="{ background: '#F9F9F9' }"
            v-else
            :data="logData"
            :stripe="true"
          >
            <el-table-column prop="updateTime" label="时间" width="250px"></el-table-column>
            <el-table-column prop="originName" label="源文件" width="420px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="convertedFileType" label="文件处理" width="240px">
              <template slot-scope="scope">
                <span v-if="scope.row.convertedFileType === 'doc'">转换为Word（*doc）</span>
                <span v-else-if="scope.row.convertedFileType === 'docx'">转换为Word（*docx）</span>
                <span v-else-if="scope.row.convertedFileType === 'xlsx'">转换为Excel（*xlsx）</span>
                <span v-else-if="scope.row.convertedFileType === 'xls'">转换为Excel（*xls）</span>
                <span v-else-if="scope.row.convertedFileType === 'pptx'">转换为PPT（*pptx）</span>
                <span v-else-if="scope.row.convertedFileType === 'ppt'">转换为PPT（*ppt）</span>
                <span v-else-if="scope.row.convertedFileType === 'pdf'">转换为PDF（*pdf）</span>
                <span v-else-if="scope.row.convertedFileType === 'zip' || scope.row.convertedFileType === 'jpg'">转换为图片（*jpg）</span>
                <span v-else-if="scope.row.convertedFileType === 'cad'">转换为CAD（*cad）</span>
                <span v-else-if="scope.row.convertedFileType === 'ofd'">转换为图片（*ofd）</span>
              </template>
            </el-table-column>
            <el-table-column prop="convertStatus" label="状态" width="150px">
              <template slot-scope="scope">
                <span v-if="scope.row.convertStatus === '1'">已完成</span>
                <span v-if="scope.row.convertStatus === '2'">转换失败</span>
                <span v-if="scope.row.convertStatus === '3'">转换中</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" width="140px">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center;">
                  <div
                    style="
                      text-decoration: none;
                      display: flex;
                      align-items: center;
                    "
                    @click="handlerDownload(scope.row)"
                    class="history-download"
                  >
                    <div style="width: 25px; height: 25px; margin-right: 6px">
                      <img
                        v-if="scope.row.convertedFileType === 'doc'"
                        src="../../assets/img/home/upload/i-word.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'docx'"
                        src="../../assets/img/home/upload/i-word.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'xlsx'"
                        src="../../assets/img/home/upload/i-excel.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'xls'"
                        src="../../assets/img/home/upload/i-excel.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'ppt'"
                        src="../../assets/img/home/upload/i-ppt.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'pptx'"
                        src="../../assets/img/home/upload/i-ppt.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'pdf'"
                        src="../../assets/img/home/upload/i-pdf.png"
                        alt
                      />
                      <img
                        v-else-if="scope.row.convertedFileType === 'zip' || scope.row.convertedFileType === 'jpg'"
                        src="../../assets/img/home/upload/i-img.png"
                        alt
                      />
                      <!-- <img v-else-if="scope.row.convertedFileType === 'zip'" src="../../assets/img/i-zip.png" alt=""> -->
                    </div>
                    <span>下载</span>
                  </div>
                  <span class="history-delete" @click="deleteData(scope.row)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="!(logData.length === 0)"
            background
            style="text-align: right; margin-top: 20px"
            layout="prev, pager, next"
            :current-page="currentPage"
            @current-change="currentChange"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 删除dialog -->
    <div class="del-dialog" v-if="delShow">
      <div class="del-mask">
        <div class="del-close" @click="delShow = false">
          <img src="../../assets/img/history/close.png" alt />
        </div>
        <div class="del-icon">
          <img src="../../assets/img/history/danger.png" alt />
        </div>
        <div class="del-text del-text-top">是否永久删除该转换记录？</div>
        <div class="del-text">删除后，将不再保留本次转换的任何记录，包括转换文档。</div>
        <div class="del-btn-wrap">
          <div class="del-channel del-btn" @click="delChanel">取消</div>
          <div class="del-ok del-btn" @click="delOk">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "@/components/NavHeader";
import { historyPost } from "@/apis/index";
import { downloadOne } from '@/apis/trans';
import { readFile } from '@/utils/readfile';
import AES from '@/utils/ase.js';
import { commonParams } from "@/utils/publicParam";
export default {
  components: {
    NavHeader
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      logData: [],
      delShow: false,
      delUrl: "",
      showEmpty: false
    };
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    } else {
      this.getList(1);
    }
  },
  methods: {
    // 获取列表
    getList(i) {
      const tableLoading = this.$loading({
        lock: true,
        text: '正在下载',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = {
        pageNum: i,
        pageSize: 10,
        ...commonParams
      };
      const robj = AES.encrypt(JSON.stringify(params))

      historyPost("/record/list", robj, {
        headers: {
          token: localStorage.getItem("token"),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        const res = JSON.parse(AES.decrypt(response));

        tableLoading.close();
        console.log(res.data);
        if (res.data.result.length <= 0) {
          this.showEmpty = true;
        } else {
          this.showEmpty = false;
        }
        this.total = res.data.page.count;
        this.logData = res.data.result;
      }).catch(err => {
        tableLoading.close();
        console.log(err)
      })
    },
    // 点击删除
    deleteData(row) {
      this.delUrl = row.name;
      this.delShow = true;
    },
    // 删除弹窗确定
    delOk() {
      const params = { name: this.delUrl, ...commonParams };
      const robj = AES.encrypt(JSON.stringify(params));

      historyPost(`/record/del`,
        robj,
        {
          headers: {
            token: localStorage.getItem("token"),
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          const res = JSON.parse(AES.decrypt(response));

          if (res.code === 0) {
            this.delShow = false;
            this.getList(this.currentPage);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 删除弹窗取消
    delChanel() {
      this.delShow = false;
    },
    // 下载
    handlerDownload(row) {
      this.donwloadFile(row.name, row.convertName);
    },
    donwloadFile(fileName, name) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      downloadOne({ filename: fileName }).then(res => {
        readFile(res, name).then(res => {
          loading.close()
        }).catch(err => {
          loading.close()
          if (err.code === 103) {
            this.$confirm('下载大于2M文件需要先购买会员', '提示', {
              confirmButtonText: '去购买',
              cancelButtonText: '我在想想',
              type: 'warning'
            }).then(() => {
              this.$router.push('product')
            })
          } else if (err.code === 102) {
            this.$confirm('您没有下载次数，充值会员可继续下载', '提示', {
              confirmButtonText: '去购买',
              cancelButtonText: '我在想想',
              type: 'warning'
            }).then(() => {
              this.$router.push('product')
            })
          }
        })
      }).catch(() => {
        loading.close()
      })
      // const token = localStorage.getItem("token");
      // const x = new XMLHttpRequest();

      // x.open("GET", url, true);
      // x.responseType = "blob";
      // x.setRequestHeader("token", token);
      // x.onload = function() {
      //   // 数据转换为文件下载
      //   const elink = document.createElement("a");
      //   const name = filename;

      //   elink.download = name;
      //   elink.style.display = "none";
      //   elink.target = "_blank";
      //   elink.href = URL.createObjectURL(x.response);
      //   document.body.appendChild(elink);
      //   elink.click();
      //   document.body.removeChild(elink);
      //   // resolve(true);
      // };
      // x.send();
    },
    // 分页切换
    currentChange(i) {
      this.getList(i);
      this.currentPage = i;
    }
  }
};
</script>

<style lang="scss" scoped>
.history {
  .log-wrap {
    width: 100%;
    min-width: 1200px;
    height: 800px;
    .log-content {
      width: 1200px;
      min-width: 1200px;
      height: 800px;
      padding: 50px 0px;
      margin: 0 auto;
      box-sizing: border-box;
      .log-title {
        font-size: 18px;
        font-family: Microsoft YaHei UI;
        font-weight: 600;
        color: #000000;
      }
      .log-text {
        margin-top: 10px;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #999999;
      }
      .log-list {
        width: 1200px;
        min-width: 1200px;
        margin-top: 54px;
        height: 600px;
      }
      .log-empty {
        padding-top: 200px;
        .log-empty-img {
          width: 220px;
          height: 130px;
          margin: 0 auto;
        }
      }
      .history-download {
        color: #0078f8;
        padding-bottom: 3px;
        height: 30px;
        border-bottom: 1px solid transparent;
        cursor: pointer;
      }
      // .history-download:hover {
      //   border-bottom: 1px solid #0078f8;
      // }
      .history-delete {
        height: 30px;
        line-height: 30px;
        margin-left: 25px;
        border-bottom: 1px solid transparent;
        cursor: pointer;
      }
      .history-delete:hover {
        border-bottom: 1px solid #000;
      }
    }
  }
  .del-dialog {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 66;
    .del-mask {
      width: 469px;
      height: 256px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 5px;
      padding: 50px 45px 0px 45px;
      box-sizing: border-box;
      .del-close {
        width: 34px;
        height: 34px;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
      .del-icon {
        width: 50px;
        height: 50px;
        margin: 0 auto;
      }
      .del-text {
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        color: #000000;
        text-align: center;
      }
      .del-text-top {
        margin: 14px 0 10px 0;
      }
      .del-btn-wrap {
        width: 207px;
        margin: 0 auto;
        display: flex;
        margin-top: 40px;
        .del-btn {
          width: 88px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          font-size: 15px;
          font-family: Microsoft YaHei UI;
          border-radius: 4px;
          box-sizing: border-box;
          cursor: pointer;
        }
        .del-channel {
          color: #0078f8;
          border: 1px solid #0078f8;
        }
        .del-channel:hover {
          background-color: #0078f8;
          color: #fff;
        }
        .del-ok {
          background-color: #0078f8;
          color: #fff;
          margin-left: 30px;
        }
        .del-ok:hover {
          background-color: #479dfa;
        }
      }
    }
  }
}
</style>
